import { CategoryStatus } from "~/gql/graphqlBase.generated";
import { type CategoryShippingUomNodeFragment } from "~/gql/queries/category.generated";

export const CATEGORY_QUERY_PARAM = "category";

export const CATEGORIES_PATH = "/fulfill/product/categories";

export const buildCategoryDeepLinkRoute = (categoryId: string): string =>
	`${CATEGORIES_PATH}?${new URLSearchParams({ [CATEGORY_QUERY_PARAM]: categoryId })}`;

export type CategoryDeepLink =
	| { category: CategoryShippingUomNodeFragment; kind: "open" }
	| { kind: "missing" }
	| { kind: "none" }
	| { kind: "pending" };

export interface CategoryDeepLinkInput {
	categoryId: null | string;
	isError: boolean;
	readNodes: readonly CategoryShippingUomNodeFragment[] | undefined;
}

const resolveCategoryDeepLink = ({ categoryId, isError, readNodes }: CategoryDeepLinkInput): CategoryDeepLink => {
	if (!categoryId) return { kind: "none" };
	if (isError) return { kind: "missing" };
	if (readNodes === undefined) return { kind: "pending" };
	const category = readNodes.find((node) => node.id === categoryId);
	if (!category || category.status === CategoryStatus.Deleted) return { kind: "missing" };
	return { category, kind: "open" };
};

export default resolveCategoryDeepLink;
